import React, { useState } from 'react';
import { Button, ButtonGroup, Modal } from '@ver-uds/react';
import { EveRoutes } from '@ver-uds/e-verify';
import ExternalLinks from '../../constants/ExternalLinks';
import newEVerifyPlusImage from '../../images/NewEvePlusModalLogo.png';

export interface NewEVerifyPlusModalProps {
  enableButtonLabel: string;
}

const NewEVerifyPlusModal: React.FC<NewEVerifyPlusModalProps> = ({ enableButtonLabel = '' }) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const footerButtons = (): React.JSX.Element => {
    let returnValue: React.JSX.Element;
    const learnMoreBtn = (
      <a
        className="usa-button usa-button--outline"
        aria-label="Click here to learn more about E-Verify+ in a new tab"
        title="Click here to learn more about E-Verify+ in a new tab"
        target="_blank"
        href={`${ExternalLinks.E_VERIFY_PLUS}`}
        rel="noopener noreferrer"
      >
        Learn More
      </a>
    );

    if (enableButtonLabel === '') {
      returnValue = learnMoreBtn;
    } else {
      return (
        <ButtonGroup>
          {learnMoreBtn}
          <Button
            variant="primary"
            as="a"
            href={EveRoutes.EVERIFY_PLUS_TOS}
            aria-label="Click here to open the E-Verify+ Terms of Service page in the current tab"
            title="Click here to open the E-Verify+ Terms of Service page in the current tab"
          >
            Enable E-Verify+
          </Button>
        </ButtonGroup>
      );
    }
    return returnValue;
  };

  return (
    <Modal
      id="new-eveplus-migration-modal"
      header="Save time with E-Verify+"
      open={isOpen}
      close={(): void => setIsOpen(false)}
    >
      <Modal.Content>
        <img src={newEVerifyPlusImage} alt="New EVerify+" className="display-block margin-bottom-3 width-full" />
        <div>
          <p>
            You and your employee can complete Form I-9 electronically right in E-Verify+, without the need to create a
            separate E-Verify case.
          </p>
          <ul>
            <li>
              <strong>Protect your business</strong> while protecting American jobs for employment authorized workers.
            </li>
            <li>
              <strong>Save valuable time</strong>, reduce data entry errors, and make your onboarding process easier.
            </li>
          </ul>
          {enableButtonLabel.length > 0 ? null : (
            <p>Want to opt in to use E-Verify+? Contact your company&apos;s program administrator!</p>
          )}
        </div>
      </Modal.Content>
      <Modal.Footer>{footerButtons()}</Modal.Footer>
    </Modal>
  );
};

export default NewEVerifyPlusModal;
